"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsCssTransitionGroup = _interopRequireDefault(require("react-addons-css-transition-group"));

var _EditLinkPopoverPreview = _interopRequireDefault(require("./EditLinkPopoverPreview"));

var _EditLinkPopoverControls = _interopRequireDefault(require("./EditLinkPopoverControls"));

var _link = require("../../constants/link");

var _popover = require("../../constants/popover");

var _iterables = require("../../utils/iterables");

var EditLinkPopoverBody =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(EditLinkPopoverBody, _Component);

  function EditLinkPopoverBody(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EditLinkPopoverBody);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EditLinkPopoverBody).call(this, props));
    _this.renderPreview = _this.renderPreview.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderEdit = _this.renderEdit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUrlKeyDown = _this.handleUrlKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EditLinkPopoverBody, [{
    key: "handleClose",
    value: function handleClose() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          updateMode = _this$props.updateMode;
      if (onClose) onClose();
      updateMode(_popover.PopoverBodyMode.PREVIEW);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(keyEvt) {
      if (keyEvt.key === _popover.KeyTypes.ESCAPE) {
        this.handleClose();
      }
    }
  }, {
    key: "handleUrlKeyDown",
    value: function handleUrlKeyDown(keyEvt) {
      if (keyEvt.key === _popover.KeyTypes.ENTER) {
        this.handleClose();
        keyEvt.preventDefault();
      }
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var _this$props2 = this.props,
          href = _this$props2.href,
          onUnlink = _this$props2.onUnlink,
          linkDisplayName = _this$props2.linkDisplayName,
          linkType = _this$props2.linkType,
          updateMode = _this$props2.updateMode,
          onAnchorPreviewClick = _this$props2.onAnchorPreviewClick;
      return _react.default.createElement(_EditLinkPopoverPreview.default, {
        href: href,
        onEdit: function onEdit() {
          updateMode(_popover.PopoverBodyMode.EDIT);
        },
        onUnlink: onUnlink,
        linkType: linkType,
        linkDisplayName: linkDisplayName,
        onAnchorPreviewClick: onAnchorPreviewClick
      });
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      var editPopoverProps = (0, _iterables.omit)(['onClose', 'onUrlKeyDown'], (0, _iterables.pick)(Object.keys(_EditLinkPopoverControls.default.propTypes), this.props));
      return _react.default.createElement(_EditLinkPopoverControls.default, (0, _extends2.default)({}, editPopoverProps, {
        onClose: this.handleClose,
        onUrlKeyDown: this.handleUrlKeyDown
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "p-x-5 p-y-3 hs-link-popover-edit",
        onKeyDown: this.handleKeyDown,
        tabIndex: "-1"
      }, _react.default.createElement(_reactAddonsCssTransitionGroup.default, {
        className: "link-transition",
        transitionName: "link-edit",
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, this.props.mode === _popover.PopoverBodyMode.PREVIEW ? _react.default.createElement("div", {
        key: 0
      }, this.renderPreview()) : _react.default.createElement("div", {
        key: 1
      }, this.renderEdit())));
    }
  }]);
  return EditLinkPopoverBody;
}(_react.Component);

exports.default = EditLinkPopoverBody;
EditLinkPopoverBody.propTypes = {
  externalLink: _react.PropTypes.bool.isRequired,
  noFollow: _react.PropTypes.bool.isRequired,
  linkText: _react.PropTypes.string.isRequired,
  canModifyLinkText: _react.PropTypes.bool,
  href: _react.PropTypes.string.isRequired,
  onUnlink: _react.PropTypes.func.isRequired,
  fetchPages: _react.PropTypes.func.isRequired,
  fetchMeetings: _react.PropTypes.func.isRequired,
  fetchAnchors: _react.PropTypes.func.isRequired,
  onUpdate: _react.PropTypes.func.isRequired,
  onClose: _react.PropTypes.func,
  onSelectFile: _react.PropTypes.func.isRequired,
  showRefAndTargetControls: _react.PropTypes.bool.isRequired,
  useEmailSubscription: _react.PropTypes.bool,
  allowFileDownload: _react.PropTypes.bool,
  linkDisplayName: _react.PropTypes.string.isRequired,
  dropdownClassName: _react.PropTypes.string,
  currentFileMeta: _react.PropTypes.object,
  linkType: _react.PropTypes.oneOf((0, _link.getAllLinkTypesForProps)()),
  mode: _react.PropTypes.oneOf([_popover.PopoverBodyMode.PREVIEW, _popover.PopoverBodyMode.EDIT]),
  updateMode: _react.PropTypes.func.isRequired,
  scopes: _react.PropTypes.array,
  userId: _react.PropTypes.number,
  onAnchorPreviewClick: _react.PropTypes.func
};
module.exports = exports.default;